import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "px-2" }

import { computed } from 'vue';
import { ProjectType } from '@/gql/graphql';
import { BBadge, BProgress, BProgressBar, BTooltip } from 'bootstrap-vue-next';
import { ComputeTaskUtils } from '@/utils/compute-utils';
import { COMPUTE_TASK_STATUS, COMPUTE_TASK_TYPES } from '@/constants';

// --- Component Properties ---
interface IProjectProgressItem {
  status: string;
  taskNames: string[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProjectStatus',
  props: {
    project: {}
  },
  setup(__props: any) {

const props = __props;

const projectProgressItems = computed<IProjectProgressItem[]>(() => {
  let items: IProjectProgressItem[] = [];
  if (!props.project || !props.project.computeTasks) return items;
  props.project.computeTasks?.forEach((task) => {
    // Check if the task has a status and name
    if (!task || !task.status || !task.name || !task.taskType) return;
    // Skip all tasks not of DATA_PIPELINE type (do not list FTP transfers, BCL-to-FASTQ, etc.)
    if (task.taskType !== COMPUTE_TASK_TYPES.DATA_PIPELINE) return;

    // Check if the status already exists in the items array
    const existingItem = items.find((item) => item.status === task.status);
    if (existingItem) {
      existingItem.taskNames.push(task.name);
    } else {
      items.push({ status: task.status, taskNames: [task.name] });
    }
  });

  /* Turn it into an array…  */
  const statusOrder = Object.values(COMPUTE_TASK_STATUS); // ["CREATING", "PENDING", …]

  /* …and then into a { status → index } map for O(1) look-ups */
  const orderMap = Object.fromEntries(
    statusOrder.map((s, idx) => [s, idx])
  ) as Record<string, number>;

  return items.sort(
    (a, b) =>
      (orderMap[a.status] ?? Infinity) - (orderMap[b.status] ?? Infinity)
  );
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (projectProgressItems.value.length === 0)
      ? (_openBlock(), _createBlock(_unref(BBadge), {
          key: 0,
          variant: "secondary"
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("No tasks", -1)
          ]))]),
          _: 1
        }))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(projectProgressItems.value, (item, idx) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
            _createVNode(_unref(BProgress), {
              class: "my-1",
              max: "100",
              id: `project-${props.project.id}-status-${idx}`,
              animated: _unref(ComputeTaskUtils).progressActive(item.status)
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(BProgressBar), {
                  value: "100",
                  variant: _unref(ComputeTaskUtils).progressVariant(item.status)
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("small", _hoisted_1, _toDisplayString(item.status), 1)
                  ]),
                  _: 2
                }, 1032, ["variant"])
              ]),
              _: 2
            }, 1032, ["id", "animated"]),
            _createVNode(_unref(BTooltip), {
              target: `project-${props.project.id}-status-${idx}`
            }, {
              default: _withCtx(() => [
                _createElementVNode("strong", null, [
                  _createVNode(_component_font_awesome_icon, {
                    icon: _unref(ComputeTaskUtils).statusIcon(item.status),
                    class: _normalizeClass(_unref(ComputeTaskUtils).statusIconClass(item.status))
                  }, null, 8, ["icon", "class"]),
                  _createTextVNode(" " + _toDisplayString(item.status), 1)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("hr", null, null, -1)),
                _createElementVNode("small", null, _toDisplayString(item.taskNames.join(', ')), 1)
              ]),
              _: 2
            }, 1032, ["target"])
          ], 64))
        }), 128))
  ]))
}
}

})